import { Tab, Tabs, Grid, Tooltip, IconButton, Typography, Box, List, ListSubheader } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Link, useLocation, useParams, useNavigate, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetSingleLotQuery } from '../../features/api/rest/apiLotsSlice';
import TreeLotsCard from './TreeLotsCard';
import QrCodesLot from './QrCodesLot';
import Spinner from '../Spinner';

function LotDetails() {
  const { opk } = useParams();
  const { ean } = useParams();
  const { id } = useParams();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { data: lot, isLoading } = useGetSingleLotQuery({ ean, opk, id });
  const backTo = () => {
    navigate(`/profile/organizations/${opk}/products/${ean}/lots`);
  };

  const menuStyle = {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'top',
    justifyContent: 'left',
    gap: 1,
    backgroundColor: 'white',
    zIndex: 1,
    marginTop: '-30px',
    paddingTop: '70px',
    width: 'calc(100% + 30px)',
    ml: '-15px',
    pl: '15px',
  };

  if (isLoading) return <Spinner />;

  return (
    <Box position="relative">
      <Typography variant="h4" py={0.5} noWrap sx={{ position: 'absolute', top: 0, zIndex: 3 }}>
        {lot?.authority} - {lot?.code}
      </Typography>
      <List>
        <ListSubheader sx={{ p: 0, zIndex: 2 }}>
          <Grid container sx={menuStyle}>
            <Grid item>
              <Tooltip title={t('organizations.product.lots.lotsDetails.tooltip')} placement="bottom">
                <IconButton onClick={backTo}>
                  <ArrowBackIcon fontSize="large" />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item flex={1} minWidth={0}>
              <Tabs value={pathname} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons={false} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tab label={t('organizations.product.lots.lotsDetails.labelLots')} component={Link} to="lotTree" value={`/profile/organizations/${opk}/products/${ean}/lots/${id}/lotTree`} />
                <Tab label={t('organizations.product.lots.lotsDetails.labelCodes')} component={Link} to="qrcodes" value={`/profile/organizations/${opk}/products/${ean}/lots/${id}/qrcodes`} />
              </Tabs>
            </Grid>
          </Grid>
        </ListSubheader>
        <Routes>
          <Route path="lotTree" element={<TreeLotsCard ean={ean} opk={opk} id={id} authority={lot.authority} code={lot.code} from={lot?.valid_from} to={lot?.valid_to} />} />
          <Route path="qrcodes" element={<QrCodesLot ean={ean} opk={opk} lpk={id} />} />
        </Routes>
      </List>
    </Box>
  );
}

export default LotDetails;
